import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastService } from '../../../services/toast.service';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [CommonModule],
  template: `
  <div class="fixed top-4 right-4 z-50 space-y-2 w-80" role="status" aria-live="polite">
    @for (t of toasts(); track t.id) {
      <div class="rounded-lg shadow-lg px-4 py-3 text-sm flex items-start gap-3 border"
           [ngClass]="{
             'bg-blue-50 text-blue-900 border-blue-200': t.type === 'info',
             'bg-green-50 text-green-900 border-green-200': t.type === 'success',
             'bg-red-50 text-red-900 border-red-200': t.type === 'error'
           }">
        <div class="pt-0.5">
          <span *ngIf="t.type==='info'">ℹ️</span>
          <span *ngIf="t.type==='success'">✅</span>
          <span *ngIf="t.type==='error'">⚠️</span>
        </div>
        <div class="flex-1 break-words">
          {{ t.message }}
        </div>
        <button class="opacity-60 hover:opacity-100" (click)="dismiss(t.id)" aria-label="Dismiss">
          ✕
        </button>
      </div>
    }
  </div>
  `
})
export class ToastContainerComponent {
  private toastService = inject(ToastService);
  toasts = computed(() => this.toastService.toasts());
  dismiss = (id: number) => this.toastService.dismiss(id);
}

